/**
 * Poly186 Logo Icon
 * Uses the public poly logo - purple works in both light and dark mode
 */
export function PolyIcon({ className }: { className?: string }) {
    return (
        <img
            src="/poly_320x320.svg"
            alt="Poly"
            className={`${className} object-contain`}
        />
    );
}
